const form = document.getElementById("form");
const firstName = document.getElementById("firstName");
const lastName = document.getElementById("lastName");
const email = document.getElementById("email");
const pass = document.getElementById("password");

const pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

form.addEventListener("submit", (e) => {
  e.preventDefault();

  validateInputs();
});

const setError = function (element, message) {
  const inputClass = element.parentElement;
  const errorDisplay = inputClass.querySelector(".error_msg");

  errorDisplay.innerText = message;
  inputClass.classList.add("invalid");
  inputClass.classList.remove("valid");
  errorDisplay.classList.add("invalid");
  errorDisplay.classList.remove("valid");
};

const success = (element) => {
  const inputClass = element.parentElement;
  const errorDisplay = inputClass.querySelector(".error_msg");

  errorDisplay.innerText = "";
  inputClass.classList.add("valid");
  inputClass.classList.remove("invalid");
};

const validateInputs = () => {
  const firstNameValue = firstName.value.trim();
  const lastNameValue = lastName.value.trim();
  const emailValue = email.value.trim();
  const passValue = pass.value.trim();

  //? First name validation

  if (firstNameValue === "") {
    setError(firstName, "First name cannot be empty");
  } else {
    success(firstName);
  }
    //? last name validation

  if (lastNameValue === "") {
    setError(lastName, "Last name cannot be empty");
  } else {
    success(lastName);
  }

    //? email validation

  if (emailValue !== "" && pattern.test(emailValue)) {
    success(email);
  } else {
    setError(email, "Looks like this is not a valid email");
  }

    //? password validation

  if (passValue === "") {
    setError(pass, "Password cannot be empty");
  } else if (passValue.length < 8) {
    setError(pass, "Password must be at least 8 characters");
  } else {
    success(pass);
  }
};
